import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	container: {
		height : props?.size,
		width  : props?.size
	}
} ) );
